export default __webpack_public_path__ + "static/media/CoreUI-Icons-Brand.fdc77ee9.svg";